export function buildColumnMaps(columns = []) {
    const detailMap = new Map(); // dataIndex → charge_item_id
    const taxMap = new Map(); // dataIndex → charge_tax_id

    for (const col of columns) {
        if (col.charge_item_id != null) {
            detailMap.set(col.dataIndex, col.charge_item_id);
        }
        if (col.charge_tax_id != null) {
            taxMap.set(col.dataIndex, col.charge_tax_id);
        }
    }

    return { detailMap, taxMap };
}